export const EpiqAdmin = "Epiq Admin";
export const EpiqProjectManager = "Epiq Project Manager";
export const EpiqTechSupport = "Epiq Tech Support";
export const EpiqTemplateAdmin = "Epiq Template Admin";
export const EpiqUser = "Epiq User";
export const Nominee = "Nominee";
export const BusinessAnalyst = "Business Analyst";

export const TemplatePermissions = {
  View: [
    EpiqProjectManager,
    EpiqTechSupport,
    BusinessAnalyst,
    EpiqTemplateAdmin,
  ],
  Download: [
    EpiqProjectManager,
    EpiqTechSupport,
    BusinessAnalyst,
    EpiqTemplateAdmin,
  ],
  Approve: [EpiqTechSupport, EpiqTemplateAdmin],
  Delete: [EpiqTechSupport, EpiqTemplateAdmin],
  Edit: [EpiqTechSupport, EpiqTemplateAdmin],
  Duplicate: [EpiqTechSupport, EpiqTemplateAdmin],
  Add: [EpiqTechSupport, EpiqTemplateAdmin], // create new
  Regenerate: [
    EpiqTemplateAdmin,
    BusinessAnalyst,
    EpiqProjectManager,
    EpiqTechSupport,
  ],
};
